import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

import { ToastrModule } from 'ngx-toastr';
import { WidgetsModule } from '../shared/widgets.module';

@NgModule({ imports: [CommonModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        ToastrModule.forRoot(),
        WidgetsModule], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class AuthModule { }
